import { noop } from '@portal/components'
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
  // https://tanstack.com/query/v4/docs/react/guides/testing#turn-off-network-error-logging
  logger: {
    log: console.log,
    warn: console.warn,
    error: process.env.NODE_ENV === 'test' ? noop : console.error,
  },
})
